import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'back-button',
  templateUrl: './back-button.component.html',
  styleUrls: ['./back-button.component.scss']
})
export class BackButtonComponent implements OnInit {
  @Input() title;
  @Output() goBack = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  handleClick() {
    this.goBack.emit();
  }
}